import { getField } from 'vuex-map-fields';

export default {
  loading: state => state.loading,
  list: state => state.list,
  currentOrganisationId: state => state.currentOrganisationId,
  apiError: state => state.apiError,
  getField,
};
